import { render, staticRenderFns } from "./NaturalAreaDiv.vue?vue&type=template&id=9d1c0366&scoped=true&"
import script from "./NaturalAreaDiv.vue?vue&type=script&lang=js&"
export * from "./NaturalAreaDiv.vue?vue&type=script&lang=js&"
import style0 from "./NaturalAreaDiv.vue?vue&type=style&index=0&id=9d1c0366&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d1c0366",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VCol,VContainer,VListItemSubtitle,VListItemTitle,VRow,VSpacer})
